var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.773,
    height: 12.691,
    viewBox: "0 0 15.773 12.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16",
    transform: "translate(-0.705 -3.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23584",
    "data-name": "Path 23584",
    d: "M15.676,16.146H1.506A.506.506,0,0,1,1,15.64V4.506A.506.506,0,0,1,1.506,4h14.17a.506.506,0,0,1,.506.506V15.64A.506.506,0,0,1,15.676,16.146ZM2.012,15.134H15.17V5.012H2.012Z",
    transform: "translate(0 0)",
    fill: "#101820",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23585",
    "data-name": "Path 23585",
    d: "M8.591,10.766A1.518,1.518,0,0,1,7.6,10.4L1.177,4.891a.506.506,0,1,1,.658-.769L8.262,9.633a.506.506,0,0,0,.658,0l6.427-5.511a.506.506,0,1,1,.658.769L9.6,10.4a1.518,1.518,0,0,1-1.012.369Z",
    fill: "#101820",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6557",
    "data-name": "Rectangle 6557",
    width: 5.476,
    height: 1.012,
    transform: "matrix(0.832, -0.555, 0.555, 0.832, 1.223, 13.7)",
    fill: "#101820",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6558",
    "data-name": "Rectangle 6558",
    width: 1.012,
    height: 5.476,
    transform: "matrix(0.555, -0.832, 0.832, 0.555, 10.839, 11.506)",
    fill: "#101820",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.3fc5a70175ad752b5fed47a71b95d071.svg";
export { ForwardRef as ReactComponent };